module.exports = __webpack_public_path__ + "img/00013.a8e8f3c5.webp";